module.exports = __webpack_public_path__ + "static/media/landing-page.3996142e.png";